<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-divider v-if="expand" />

    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
        >
          <v-container>

            <v-row justify="center" class="mx-0 px-2">

              <v-combobox
                multiple
                auto-select-first
                label="Brands (filter)"
                class="col-6 pl-0"
                hide-details
                @input="bonusClearBrandFilter"
                :search-input.sync="brandsFilterInput"
                v-model="brandsFilter"
                :items="brands"
                clearable
              />

              <v-autocomplete
                label="Exclusive for Game"
                item-text="name"
                item-value="game_id"
                hide-details
                class="col-6 pr-0"
                clearable
                v-model="value.game_id"
                :items="filteredGames"
              />

            </v-row>
            <v-row justify="center" class="mx-0 px-2">
              <v-autocomplete
                label="Exclusive for Brand"
                hide-details
                clearable
                class="col-6 pl-0"
                v-model="value.brand_exclusive"
                :items="brands"
              />
              <v-autocomplete
                label="Exclusive for System"
                hide-details
                clearable
                class="col-6 pr-0"
                v-model="value.system_exclusive"
                :items="systems"
              />
            </v-row>
          </v-container>
        </v-form>
      </v-expand-transition>
    </v-card-text>
  </v-card>

</template>

<style lang="scss">

  .v-card.v-card--disabled .v-card__title {
    background: #cbcbcb;
  }

  .v-card.v-card--disabled.bt-step-card {
    border-left-color: gray;
  }

  .v-card.bt-step-card {
    border-left: 4px solid #4caf50;
  }

</style>

<script>
  export default {

    props: {
      step: {},
      value: {},
      next: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      games: {},
      brands: {},
      systems: {},
      types: {},
      expand: { default: () => false },
    },

    data: () => ({
      // valid: false
      brandsFilter: [],
      brandsFilterInput: '',
      filteredBonusGames: [],
      providerBrandsAliases: [],
      providerSystemsAliases: [],
    }),

    methods: {
      bonusClearBrandFilter () {
        this.brandsFilterInput = ''
      },
      complete () {

        this.completed = true

        this.next(this.step)
      }
    },

    computed: {
      filteredGames: function () {
        return this.games.filter(g => {
          return this.brandsFilter.length < 1 || (this.brandsFilter.includes(g.brand_alias))
        })
      },
      settings: function () {
        return this.types[this.value.type] || {}
      },
      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      expand (v) {
        this.editable = true
      },
    }
  }
</script>

